import { createFileRoute } from '@tanstack/react-router';
import React, { SVGProps } from 'react';

import { Heading } from '@/common/components/heading';
import { Link } from '@/common/components/link';
import { Text } from '@/common/components/text';
import { BuildingIcon, HouseIcon } from '@/icons/fa/duotone-solid';
import { ChevronRightIcon } from '@/icons/fa/regular';
import { useAuth } from '@/shared/auth/use-auth';

export const Route = createFileRoute('/apply/')({
  component: ApplyRoute
});

type ServiceOption = {
  name: string;
  description: string;
  href: string;
  icon: React.FunctionComponent<SVGProps<SVGSVGElement>>;
};

const serviceOptions: ServiceOption[] = [
  {
    name: 'Residential Services',
    description: 'Apply for new residential services.',
    href: '/apply/residential',
    icon: HouseIcon

  },
  {
    name: 'Commercial Services',
    description: 'Apply for new commercial services.',
    href: '/apply/commercial',
    icon: BuildingIcon

  }
];

function ApplyRoute() {
  const { isAuthenticated } = useAuth();
  return (
    <div className="mx-auto max-w-xl p-9">
      <Heading>Apply for Service</Heading>

      <Text>Thank you for your interest in applying for service(s) with Talquin Electric Cooperative. Get started selecting your service needs below.</Text>

      <ul className="mt-6 divide-y divide-gray-200 border-y border-gray-200">
        {serviceOptions.map((option, idx) => (
          <li key={idx}>
            <div className="group relative flex items-start space-x-3 py-4">
              <div className="shrink-0">
                <span className="bg-primary-700/10 inline-flex size-10 items-center justify-center rounded-lg">
                  <option.icon className="size-6 text-primary-700"/>
                </span>
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-sm font-medium text-gray-900">
                  <Link to={option.href as unknown as any}>
                    <span aria-hidden="true" className="absolute inset-0" />
                    {option.name}
                  </Link>
                </div>
                <p className="text-sm text-gray-500">{option.description}</p>
              </div>
              <div className="shrink-0 self-center">
                <ChevronRightIcon aria-hidden="true" className="size-5 text-gray-400 group-hover:text-gray-500" />
              </div>
            </div>
          </li>
        ))}
      </ul>
      <div className="mt-6 flex">
        <Link to={isAuthenticated ? '/applications' : '/login'} className="text-sm font-medium text-primary-800 hover:text-primary-700">
          Or continue an existing application
          <span aria-hidden="true"> &rarr;</span>
        </Link>
      </div>
    </div>
  );
}
